import { createAsyncThunk } from "@reduxjs/toolkit";

export const createOrderAction = createAsyncThunk(
    "createOrderAction",
    async (data) => {
        const response = await fetch(
            "https://52lku5p2bj.execute-api.ap-south-1.amazonaws.com/Prod/prod_brilljust_razorpay_createOrder",
            {
                method: "POST",
                body: JSON.stringify(data.body),
                headers: new Headers({
                    "Authorization": `${data.userToken}`,
                    'Content-Type': 'application/json'
                }),
            }
        );
        return response.json();
    }
);